import { render, staticRenderFns } from "./SectionSelector.vue?vue&type=template&id=02323406&"
import script from "./SectionSelector.vue?vue&type=script&lang=js&"
export * from "./SectionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsProjectSectionBuilding: require('/app/components/sections/project/SectionBuilding.vue').default,SectionsProjectSectionParking: require('/app/components/sections/project/SectionParking.vue').default})
